'use strict';

(function () {

  angular.module('zp').controller('searchController', searchController);

  /**@ngInject */
  function searchController($q, $timeout, $state, $rootScope, GooglePlacesConfig, searchBackgroundConfig, vendorsService, SearchService) {

    var vm = this;
    var vendorsJustOpened = false;

    vm.showOptions = false;
    vm.showCurrentLocation = true;
    vm.currentLocationName = null;
    vm.addressOptions = null;
    vm.addressModel = null;
    vm.searchAreaBackground = null;
    vm.searchAreaOpacity = null;
    vm.dateFormat = 'dd/MM/yyyy';
    vm.dateOptions = {
      formatYear: 'yy',
      maxDate: new Date(2020, 5, 22),
      minDate: new Date(),
      startingDay: 1,
      showWeeks: false
    };
    vm.showDatePicker = false;

    vm.sanitizeVendor = sanitizeVendor;
    vm.toggleOptions = toggleOptions;
    vm.toggleCurrentLocation = toggleCurrentLocation;
    vm.onAddressChange = onAddressChange;
    vm.toggleDatepicker = toggleDatepicker;
    vm.selectVendor = selectVendor;
    vm.closeVendors = closeVendors;
    vm.openShop = openShop;
    vm.openHoneyMoon = openHoneyMoon;

    ///////////////////////////////////////////

    (function () {
      vm.addressOptions = GooglePlacesConfig.to;
      vm.currentLocationName = 'Beograd, Serbia';
      setSearchAreaBackground().then(loadSearchModel);
    })();

    function toggleOptions() {
      vm.showOptions = !vm.showOptions;
      vendorsJustOpened = true;
    }

    function toggleCurrentLocation() {
      vm.showCurrentLocation = !vm.showCurrentLocation;
    }

    function onAddressChange() {
      vm.currentLocationName = vm.addressModel.formatted_address;
      vm.showCurrentLocation = true;
      vm.searchModel.latitude = vm.addressModel.geometry.location.lat();
      vm.searchModel.longitude = vm.addressModel.geometry.location.lng();
      vm.searchModel.city = vm.addressModel.formatted_address;
      setSearchAreaBackground();
    }

    function sanitizeVendor(vendor) {
      return vendor.replace(/ /g, '-').toLowerCase();
    }

    function loadSearchModel() {
      return SearchService.getSearchModel().then(function (s) {
        vm.searchModel = s;
        if ($state.current.name.indexOf('nav.main') !== -1) {
          vm.searchModel.selectedCategory = null;
        }
        vm.currentLocationName = vm.searchModel.city;
      });
    }

    function openShop() {
      $state.go('nav.shop');
    }

    function openHoneyMoon() {
      $state.go('nav.honey-moon');
    }

    function selectVendor(vendor) {
      vm.searchModel.selectedCategory = vendor;
      $state.go('nav.results', { vendor: vendor });
    }

    function closeVendors() {
      if (!vendorsJustOpened) {
        vm.showOptions = false;
      }
      vendorsJustOpened = false;
    }

    function setSearchAreaBackground() {
      return $q.when(function () {
        $timeout(function () {
          if (!vm.addressModel || vm.addressModel.address_components.length < 2) {
            $rootScope.searchAreaBackground = searchBackgroundConfig['default'];
            $rootScope.searchAreaOpacity = 0;
            $timeout(function () {
              $rootScope.searchAreaOpacity = 1;
            }, 200);
            return true;
          }
          var adminAreaIndex = vm.addressModel.address_components.length - 2;
          var adminLocalArea = vm.addressModel.address_components[adminAreaIndex];
          var areaBackground = searchBackgroundConfig[adminLocalArea.long_name];
          $rootScope.searchAreaBackground = !!areaBackground ? areaBackground : searchBackgroundConfig['default'];
          $rootScope.searchAreaOpacity = 0;
          $timeout(function () {
            $rootScope.searchAreaOpacity = 1;
          }, 200);
        }, 200);
        return true;
      }());
    }

    function toggleDatepicker() {
      vm.showDatePicker = !vm.showDatePicker;
    }
  }
})();